import React,{Component} from 'react';
import {variables} from '../../Variables.js';
import MyPage from "../../../src/MyPage";
import SubTabsGeneralParams from "../../../src/SubTabsGeneralParams";
import { isSuperAdmin } from "./../../helpers/user.js";
import axiosService from '../../helpers/axios';


  export default class GeneralParamsPalletPoDelay extends Component{ 

    constructor(props){
      super(props);

      this.state={
          palletpodelays:[],
          modalTitle:"",
          palletpodelay:"",
          palletpodelayid:0,
      }
  }



refreshList(){
  axiosService.get('/palletpodelay/')
  .then(response=>{
      const data = response.data?.results ?? response.data;
      this.setState({palletpodelays:data});
  });
}



componentDidMount(){
  this.refreshList();
}

changePalletPoDelay =(e)=>{
  this.setState({palletpodelay:e.target.value});
}
changePalletPoDelayID =(e)=>{
  this.setState({palletpodelayid:e.target.value});
}

addClick(){
  this.setState({
      modalTitle:"Add PalletPoDelay",
      palletpodelayid:0,
      palletpodelay: "",
  });
}
editClick(dep){
  this.setState({
      modalTitle:"Edit PalletPoDelay",
      palletpodelayid:dep.palletpodelayid,
      palletpodelay:dep.palletpodelay,
      intitialPalletPoDelay:dep.palletpodelay,
  });
}

createClick() {
  const { palletpodelay,  } = this.state;

  if (!palletpodelay) {
    alert('Pallet PoDelay is required');
    return;
  }


  axiosService.post('/palletpodelaycreate/', {
    palletpodelay: palletpodelay
  })
    .then(result => {
      alert('PalletPoDelay created');
      this.refreshList();
      //window.location.reload(); // Refresh the page
    })
    .catch(error => {
      alert('Failed');
    });
}


updateClick(id){

  const { palletpodelay, intitialPalletPoDelay } = this.state;

   // Check if any changes are detected
   if (
    palletpodelay === intitialPalletPoDelay
  ) {
    alert('No changes detected');
    return;
  }

  if (!palletpodelay) {
    alert('Application Name is required');
    return;
  }
  

  axiosService.patch('/palletpodelay/'+id+'/',{
      palletpodelayid:this.state.palletpodelayid,
      palletpodelay:this.state.palletpodelay
  })
  .then((result)=>{
      alert('Update succesful');
      this.refreshList();
      //window.location.reload(); // Refresh the page
  })
  .catch((error)=>{
      alert('Failed');
  })
}

deleteClick(id) {
 
  if (window.confirm('Are you sure?')) {
    axiosService.delete('/palletpodelay/' + id + '/')
      .then(res => {
        alert('Delete successful');
        this.refreshList();
        //window.location.reload(); // Refresh the page
      })
      .catch(error => {
        alert(error?.response?.data?.error || error?.message || 'Delete failed');
      });
  }
}


render(){
  const {
      palletpodelays,
      modalTitle,
      palletpodelayid,
      palletpodelay,
  }=this.state;

  return(
<div className="scrollable-container">
<MyPage />
<SubTabsGeneralParams />
<button type="button"
disabled={!isSuperAdmin()}
className="btn btn-primary m-2 float-end"
data-bs-toggle="modal"
data-bs-target="#exampleModal"
onClick={()=>this.addClick()}
style={{  height: "28px", fontSize: "12px" ,textAlign:"center"}}
>

  Add PalletPoDelay
</button>
<div className="table-container-single">
<table className="table table-striped">
<thead>
<tr className="header-row-fixed">
  <th style={{  fontSize: "12px" ,textAlign:"center"}}>
      <div className="d-flex flex-row align-items-center justify-content-center">
      <input className="form-control m-2"
       style={{ width: "70px", height:"30px" ,fontSize: "12px"}} // Set the width to 200 pixels (you can adjust the value as needed)
      onChange={this.changePalletPoDelayID}
      placeholder="Filter"/>

      </div>
      Pallet PoDelayID
  </th>
  <th style={{  fontSize: "12px" ,textAlign:"center"}}>
  <div className="d-flex flex-row align-items-center justify-content-center">
  <input className="form-control m-2"
   style={{ width: "200px", height:"30px",fontSize: "12px" }} // Set the width to 200 pixels (you can adjust the value as needed)
      onChange={this.changePalletPoDelay}
      placeholder="Filter"/>

      </div>
      PalletPoDelay (months)

  </th>
  <th style={{  fontSize: "12px" ,textAlign:"center"}}>
      Options
  </th>
</tr>
</thead>
<tbody>
  {palletpodelays.map(dep=>
      <tr key={dep.palletpodelayid}  className="row-hover">
          <td className="table-text">{dep.palletpodelayid}</td>
          <td className="table-text">{dep.palletpodelay}</td>
          <td className="table-text">
          <div style={{ display: "flex", justifyContent: "center" }}>
          <button type="button"
          disabled={!isSuperAdmin()}
          className="btn btn-light mr-1  p-0"
          data-bs-toggle="modal"
          data-bs-target="#exampleModal"
          onClick={()=>this.editClick(dep)}>
              <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" className="bi bi-pencil-square" viewBox="0 0 16 16">
              <path d="M15.502 1.94a.5.5 0 0 1 0 .706L14.459 3.69l-2-2L13.502.646a.5.5 0 0 1 .707 0l1.293 1.293zm-1.75 2.456-2-2L4.939 9.21a.5.5 0 0 0-.121.196l-.805 2.414a.25.25 0 0 0 .316.316l2.414-.805a.5.5 0 0 0 .196-.12l6.813-6.814z"/>
              <path fillRule="evenodd" d="M1 13.5A1.5 1.5 0 0 0 2.5 15h11a1.5 1.5 0 0 0 1.5-1.5v-6a.5.5 0 0 0-1 0v6a.5.5 0 0 1-.5.5h-11a.5.5 0 0 1-.5-.5v-11a.5.5 0 0 1 .5-.5H9a.5.5 0 0 0 0-1H2.5A1.5 1.5 0 0 0 1 2.5v11z"/>
              </svg>
          </button>

          </div>

          </td>
      </tr>
      )}
</tbody>
</table>
</div>

<div className="modal fade" id="exampleModal" tabIndex="-1" aria-hidden="true">
  <div className="modal-dialog modal-lg modal-dialog-centered">
    <div className="modal-content">
      <div className="modal-header">
        <h5 className="modal-title" style={{ fontSize: "12px" }} >{modalTitle}</h5>
        <button type="button" className="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
      </div>
      <div className="modal-body">
      <div className="input-group mb-3">
          <span className="input-group-text" style={{ fontSize: "12px" }} >PalletPoDelay (months)</span>
          <input
            type="text"
            className={`form-control`}
            value={palletpodelay}
            onChange={this.changePalletPoDelay}
            style={{ fontSize: "12px" }} 
          />
        </div>

        {palletpodelayid === 0 ? (
          <button type="button" className="btn btn-primary float-start" onClick={() => this.createClick()}>
            Create
          </button>
        ) : null}

        {palletpodelayid !== 0 ? (
          <button type="button" className="btn btn-primary float-start" onClick={() => this.updateClick(palletpodelayid)}>
            Update
          </button>
        ) : null}
      </div>
    </div>
  </div>
</div>


</div>
  )
}


  }